import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import MoreIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import DotIndicator from '@wix/da-ds/pkg/Indicators/DotIndicator';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ConditionalTooltip from '../../lego/ConditionalTooltip';
import BetaBadge from '../../../BetaBadge';
import s from './NetworkBarItem.scss';
const NetworkBarItem = ({ children, tooltipContent, isCollapsed = false, className, linkClassName, iconClassName, isSelected, url, tabIndex, biData, menuItems, menuBiData, hasNewContent, betaBadge, icon, menuClassName, showTooltip = true, onClick, id, 'aria-label': ariaLabel, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded })=>{
    const [isActionsDropdownOpen, setActionsDropdownOpen] = useState(false);
    const toggleDropdown = useCallback(()=>setActionsDropdownOpen((isOpen)=>!isOpen), []);
    return /*#__PURE__*/ React.createElement(ConditionalTooltip, {
        tooltipContent: tooltipContent,
        showTooltip: showTooltip && isCollapsed
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isSelected && s['selected'], isCollapsed && s['collapsed'], isActionsDropdownOpen && s['actions-open'], menuItems && s['with-actions'], (url || onClick) && s['clickable'], className)
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        id: id,
        href: url,
        className: classnames(s['item-link'], linkClassName),
        tabIndex: tabIndex,
        biData: biData,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['icon'], iconClassName)
    }, icon, hasNewContent && /*#__PURE__*/ React.createElement(DotIndicator, {
        color: "red",
        className: s['new-indicator']
    })), !isCollapsed && children), !isCollapsed && menuItems && /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        className: classnames(s['actions'], menuClassName),
        contextMenuClassName: s['menu'],
        popperClassName: "networkbar-group-dropdown",
        withButton: true,
        noIconHoverEffect: true,
        items: menuItems,
        onToggle: toggleDropdown,
        isInPopup: true,
        usePortal: true,
        biData: isActionsDropdownOpen ? undefined : menuBiData
    }, /*#__PURE__*/ React.createElement(MoreIcon, {
        disableDefaultColors: true
    })), !isCollapsed && betaBadge && /*#__PURE__*/ React.createElement(BetaBadge, {
        className: s['beta-badge'],
        badgeType: betaBadge,
        variant: "small"
    })));
};
NetworkBarItem.displayName = 'NetworkBarItem';
export default NetworkBarItem;
